<script setup lang="ts">
import ToggleSwitch from '@mobile/components/ToggleSwitch/ToggleSwitch.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import { useSportOptions } from '../../../../Sports/composables/useSportOptions'
import { useEventRelationSettings } from '../../../../Sports/useEventRelationSettings'

// inject
const eventInjections = useEventInjections()
const { sport } = eventInjections
const sportOptionsComposable = useSportOptions(sport)
const { showIncidentsWithSameEventTimeFilterEnabled } =
  useEventRelationSettings(eventInjections, sportOptionsComposable)
</script>

<template>
  <div class="flex flex-col">
    <span class="pb-1 text-xs">Show same time</span>
    <ToggleSwitch
      v-model:value="showIncidentsWithSameEventTimeFilterEnabled"
      class="-ml-2 py-2"
    />
  </div>
</template>
